import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-star-rating',
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.css'],
    standalone: false
})
export class StarRatingComponent {
  @Input() rating: number;
  @Input() type: string;
  @Output() ratingChange = new EventEmitter<number>();

  ratingText: string;

  changeRating(rating: number){
    this.ratingChange.emit(rating);
    const text = rating === 1 ? ' Star' : ' Stars'
    this.ratingText = rating ? rating + text : null;
  }
}
